module.exports = __webpack_public_path__ + "img/logo-supporter.d5d9e1b9.png";